<template>
  <f7-page name="credits-transfer-history">
    <f7-navbar >
      <f7-nav-left back-link="" class="color-secondary" :class="{'popup-close': isFirstRoute}"></f7-nav-left>
      <f7-nav-title>{{ $t('CREDITS_MSG016') }}</f7-nav-title>
      <!--<div class="title">{{ $t('CREDITS_MSG016') }}</div>-->
      <f7-nav-right>
        <!--<f7-link back popup-close class="color-black"><i class="pi pi-times"></i></f7-link>-->
        <f7-link back popup-close>
          <Button icon="pi pi-times" class="p-button-rounded p-button-text p-button-secondary " :class="{'popup-close': isFirstRoute}" />
        </f7-link>
      </f7-nav-right>
    </f7-navbar>

    <form class="p-grid p-fluid no-margin padding-vertical bg-color-white" @submit.prevent="onFormSubmit">
      <div class="p-col-12 p-sm-6 p-md-4">
        <!--<label>{{ $t('COM_MSG015') }}</label>-->
        <div class="p-inputgroup">
          <span class="p-inputgroup-addon">
            <i class="icon f7-icons size-18">calendar</i>
          </span>
          <Calendar
              v-model="selectedMonth"
              :placeholder="$t('COM_MSG015')"
              class="p-inputtext-sm"
              view="month"
              dateFormat="mm/yy"
              :maxDate="maxDateValue"
              :manualInput="false"
          />
        </div>
      </div>

      <div class="p-col-12 p-sm-6 p-md-5">
        <!--<label>{{ $t('CREDITS_MSG002') }}</label>-->
        <AutoComplete
            forceSelection
            v-model="subAccount"
            :suggestions="filteredSubAccounts"
            @complete="searchCustomer($event)"
            field="CustomerName"
            :placeholder="$t('CREDITS_MSG002')"
        >
          <template #item="slotProps">
            <div>{{ slotProps.item.CustomerName }} <span class="text-color-gray">({{ slotProps.item.Account }} - {{ slotProps.item.Email }})</span></div>
          </template>
        </AutoComplete>
        <small>{{ $t('COM_MSG019') }}</small>
      </div>

      <div class="p-col-12 p-md-3">
        <Button type="submit" :label="$t('COM_MSG011')" icon="pi pi-search" iconPos="left" class="color-green p-button-sm"/>
      </div>
    </form>

    <DataTable :value="history" :loading="isLoading" class="p-datatable-sm p-datatable-striped" sortField="CreateTime" :sortOrder="-1">
      <template #empty>
        {{ $t('COM_MSG012') }}
      </template>

      <Column field="CreateTime" :sortable="true" :header="$t('CREDITS_MSG017')" :style="{width:'180px'}">
        <template #body="{data}">
          {{dateFormat(data.CreateTime+'z', 'datetime')}}
        </template>
      </Column>
      <Column field="Credits" :sortable="true" :header="$t('CREDITS_MSG007')" :style="{width:'80px'}"></Column>
      <!--<Column field="CreatorName" header="From"></Column>-->
      <Column field="ToCustomerName" :sortable="true" :header="$t('CREDITS_MSG018')"></Column>
      <Column field="ToUserName" :sortable="true" :header="$t('CREDITS_MSG019')"></Column>
    </DataTable>

  </f7-page>
</template>

<script>
import { ref, onMounted, computed, reactive  } from 'vue'
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Button from "primevue/button";
import InputText from 'primevue/inputtext';
import Dropdown from 'primevue/dropdown';
import Tooltip from 'primevue/tooltip';
import Calendar from 'primevue/calendar';
import AutoComplete from 'primevue/autocomplete';
import {mapGetters, useStore} from "vuex";
import {dateFormat} from '../../js/helper'


export default {
  name: "credits-transfer-history",

  components: {
    DataTable,
    Column,
    Button,
    InputText,
    Dropdown,
    Calendar,
    AutoComplete
  },

  directives: {
    'tooltip': Tooltip
  },

  props: {
    f7router: Object,
    f7route: Object,

    //isOpened: { type: Boolean, default: false }
    isFirstRoute: { type: Boolean, default: false },
    UserCode: { type: String, default: null },
    Name: { type: String, default: null },
  },

  data() {
    let today = new Date()
    let selectedMonth = today
    let maxDateValue = today
    return {
      isLoading: false,
      selectedMonth,
      maxDateValue,
      subAccount: null,
      filteredSubAccounts: [],
      history: [],
    }
  },

  computed:{
    ...mapGetters({
      MajorToken: 'MajorToken',
      MinorToken: 'MinorToken',
    }),
  },

  mounted() {

    this.onFormSubmit()
  },

  methods: {
    dateFormat(dateStr, outFormat, inFormat){
      return dateFormat(dateStr, outFormat, inFormat )
    },
    async searchCustomer(event) {
      if(!event.query.trim().length || event.query.trim().length < 4 ){
        this.filteredSubAccounts = [];
        return
      }

      let customers = await this.$store.dispatch('QUERY_CUSTOMERS', {
        MinorToken: this.MinorToken,
        MajorToken: this.MajorToken,
        q: event.query.toLowerCase()
      })

      if(!customers){
        this.filteredSubAccounts = []
        return
      }

      this.filteredSubAccounts = customers;
    },
    async onFormSubmit() {
      this.isLoading = true
      let list = await this.$store.dispatch('CREDITS_TRANSFER_HISTORY', {
        MinorToken: this.MinorToken,
        MajorToken: this.MajorToken,
        FromCustomerCode: !this.subAccount || !this.subAccount.CustomerCode ? this.MajorToken : this.subAccount.CustomerCode ,
        Year: this.selectedMonth.getFullYear(),
        Month: this.selectedMonth.getMonth()+1
      })
      this.isLoading = false
      if(!list || !Array.isArray(list)){
        this.history = []
        return
      }
      this.history = list;

      console.log(list)

    }
  },

  /*setup(){
    const store = useStore()
    let MinorToken = computed(() => store.state.MinorToken)
    let MajorToken = computed(() => store.state.MajorToken)


    let today = new Date()
    let selectedMonth = ref(today)
    let maxDateValue = today

    let subAccount = ref(null)
    let filteredSubAccounts = reactive({list: []})
    let history = reactive({list: []})


    onMounted(()=> {
      onFormSubmit()
    })

    async function searchCustomer(event) {
      if(!event.query.trim().length || event.query.trim().length < 4 ){
        filteredSubAccounts.list = [];
        return
      }

      let customers = await store.dispatch('QUERY_CUSTOMERS', {
        MinorToken: MinorToken.value,
        MajorToken: MajorToken.value,
        q: event.query.toLowerCase()
      })

      if(!customers){
        filteredSubAccounts.list = []
        return
      }

      filteredSubAccounts.list = customers;
    }

    async function onFormSubmit() {
      let list = await store.dispatch('CREDITS_TRANSFER_HISTORY', {
        MinorToken: MinorToken.value,
        MajorToken: MajorToken.value,
        FromCustomerCode: MajorToken.value,
        Year: selectedMonth.value.getFullYear(),
        Month: selectedMonth.value.getMonth()+1
      })

      if(!list){
        return
      }
      history.list = list;

      console.log(list)

    }
    return {
      selectedMonth,
      maxDateValue,
      subAccount,
      filteredSubAccounts,
      history,

      onFormSubmit,
      searchCustomer
    }
  }*/
}
</script>

<style scoped>

</style>